// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WorkshopMedia_wrapper__2ulWk","video":"WorkshopMedia_video__2vKeY","image":"WorkshopMedia_image__HFuBq"};